import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from '@angular/core';

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";

//Models
import { ActivatedRoute, Params } from "@angular/router";
import { RegisterService } from "../../../../services/cms/register.service";

import { Subscription } from 'rxjs/Subscription';
import { SeoService } from '../../../../services/core/seo.service';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ''
})

export class RegistrationConfirmationComponent implements OnInit {
    data: any = {};

    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private cmsComponentService: CmsComponentService,
            private templateService: TemplateService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        let registrationConfirmation: any;
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let compTemplateSub = this.templateService.getComponentTemplate("registrationConfirmationPageTemplate").subscribe(result => {
             if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            if (this.isBrowser) {
                registrationConfirmation = result;
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(registrationConfirmation,header);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });

        this.subManager.add(compTemplateSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    //Creates component to inject
    private createSubComponent(registrationConfirmation: any,header:any) {
        @Component({
            template: registrationConfirmation
        })

        class ChildComponent implements OnInit {

            constructor
                (
                    private routesService: RoutesService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private activatedRoute: ActivatedRoute,
                    private registerService: RegisterService
                ) { }

            private success: boolean = false;
            private failed: boolean = false;
            private active: boolean = false;
            private pageIsInit: boolean = false;

            headerData: any = header;
            footerData: any = registrationConfirmation.FooterData;


            subManager = new Subscription();

            ngOnInit() {
                if (this.isBrowser == false) {
                    return;
                }

                let paramsSub = this.activatedRoute.params.subscribe((params: Params) => {
                    let userId = params['userid'];

                    this.checkActivation(userId);
                });

                this.subManager.add(paramsSub);
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
            }

            checkActivation(userId) {
                let confirmRegSub = this.registerService.confirmationRegistration(userId)
                    .subscribe(response => {
                        if (response == "1") {
                            this.success = true;
                        }
                        else if (response == "-1") {
                            this.active = true;
                        }
                        else {
                            this.failed = true;
                        }
                    })

                this.subManager.add(confirmRegSub);
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }

        }

        return ChildComponent;
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/user/sys/registration-confirmation.component.ts